import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
`;
const StyledLabel = styled.label`
  width: 140px;
  flex-shrink: 0;
  color: ${props => props.theme.colors.black};
  font-size: inherit;
`;
const StyledSelect = styled.select`
  margin-right: auto;
  width: 100%;
  color: ${props => props.theme.colors.black};
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.borderSubtle};
  border-radius: 6px;
  padding: ${p => p.theme.spacing.sm} ${p => p.theme.spacing.base};
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.2s;
  accent-color: ${p => p.theme.colors.deepGrey};

  &:hover:not([disabled]) {
    border-color: ${p => p.theme.colors.deepGrey};
  }

  &:focus-visible {
    outline: 2px solid ${p => p.theme.colors.focusRing};
    outline-offset: 1px;
  }

  option {
    background-color: ${p => p.theme.colors.white};
    color: ${p => p.theme.colors.black};
  }

  option:hover,
  option:checked {
    background-color: ${p => p.theme.colors.lightGrey};
    color: ${p => p.theme.colors.black};
  }

  :disabled {
    background-color: ${p => p.theme.colors.lightGrey};
    color: ${p => p.theme.colors.midGrey};
    cursor: not-allowed;
  }
`;

export interface CustomVMDropdownOption {
  name: string;
  value: any;
}

export const CustomVMDropdown = ({
  labelText,
  options,
  emptyText,
  placeholderText,
  disabled,
  ...props
}: any) => {
  return (
    <StyledContainer>
      <StyledLabel>{labelText}</StyledLabel>
      <StyledSelect
        name={props.name}
        onChange={props.onChange}
        disabled={disabled}
        value={props.value}
      >
        {options.length === 0 && emptyText ? (
          <option disabled key={emptyText} value={''}>
            {emptyText}
          </option>
        ) : null}
        {options.length > 0 && placeholderText ? (
          <option disabled key={placeholderText} value={''}>
            {placeholderText}
          </option>
        ) : null}
        {options.map((option: CustomVMDropdownOption) => (
          <option key={option.name} value={option.value}>
            {option.name}
          </option>
        ))}
      </StyledSelect>
    </StyledContainer>
  );
};
